/**
 * Add parent flag to user document for Firestore security rules
 */
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db, auth } from '../firebase.js';

async function addParentFlag(schoolId) {
  try {
    const user = auth.currentUser;
    if (!user) {
      console.error('❌ Not logged in');
      return;
    }

    console.log('👤 User ID:', user.uid);
    if (schoolId) {
      console.log('🏫 School ID:', schoolId);
    }

    const userRef = doc(db, 'users', user.uid);
    const userDoc = await getDoc(userRef);
    const userData = userDoc.data();

    console.log('📄 Current user data:', userData);

    if (!userData?.parent) {
      console.log('➕ Adding parent flag...');
      await setDoc(userRef, { parent: true }, { merge: true });
      console.log('✅ Parent flag added! Refresh the page.');
    } else {
      console.log('✅ Parent flag already exists');
    }

    return userData;
  } catch (error) {
    console.error('❌ Error:', error);
    throw error;
  }
}

export { addParentFlag };
